import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Cases = () => {
  const { t } = useLanguage();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transform: `translateY(${scrollY * 0.35}px)`,
            willChange: 'transform'
          }}
        />
        <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(11,112,42,0.2)_1px,transparent_1px),linear-gradient(90deg,rgba(11,112,42,0.2)_1px,transparent_1px)] bg-[size:40px_40px]" style={{ transform: `translateY(${scrollY * 0.15}px)`, willChange: 'transform' }} />
        <div className="absolute inset-0 bg-gradient-to-b from-[#014421]/30 to-black" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">{t.cases.title}</h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">{t.cases.subtitle}</p>
        </div>
      </section>

      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Case 1 */}
            <article className="group bg-[#014421]/30 border border-[#0B702A]/20 rounded-xl overflow-hidden hover:border-[#0B702A]/60 transition-all duration-300 hover:scale-[1.02]">
              <div className="relative h-64 overflow-hidden">
                <img src="https://images.unsplash.com/photo-1563206767-5b18f218e8de?w=600" alt="Case 1" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-3 py-1 bg-[#0B702A] text-white text-xs font-semibold rounded-full mb-2">
                    {t.cases.casesList.ecommerce.category}
                  </span>
                  <h3 className="text-2xl font-bold">{t.cases.casesList.ecommerce.title}</h3>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                  <span className="font-semibold">{t.cases.client}</span>
                  <span>{t.cases.casesList.ecommerce.client}</span>
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed">{t.cases.casesList.ecommerce.description}</p>
                <div>
                  <h4 className="text-lg font-bold mb-3 text-[#0B702A]">{t.cases.results}</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.ecommerce.results[0]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.ecommerce.results[1]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.ecommerce.results[2]}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </article>

            {/* Case 2 */}
            <article className="group bg-[#014421]/30 border border-[#0B702A]/20 rounded-xl overflow-hidden hover:border-[#0B702A]/60 transition-all duration-300 hover:scale-[1.02]">
              <div className="relative h-64 overflow-hidden">
                <img src="https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=600" alt="Case 2" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-3 py-1 bg-[#0B702A] text-white text-xs font-semibold rounded-full mb-2">
                    {t.cases.casesList.banking.category}
                  </span>
                  <h3 className="text-2xl font-bold">{t.cases.casesList.banking.title}</h3>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                  <span className="font-semibold">{t.cases.client}</span>
                  <span>{t.cases.casesList.banking.client}</span>
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed">{t.cases.casesList.banking.description}</p>
                <div>
                  <h4 className="text-lg font-bold mb-3 text-[#0B702A]">{t.cases.results}</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.banking.results[0]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.banking.results[1]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.banking.results[2]}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </article>

            {/* Case 3 */}
            <article className="group bg-[#014421]/30 border border-[#0B702A]/20 rounded-xl overflow-hidden hover:border-[#0B702A]/60 transition-all duration-300 hover:scale-[1.02]">
              <div className="relative h-64 overflow-hidden">
                <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600" alt="Case 3" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-3 py-1 bg-[#0B702A] text-white text-xs font-semibold rounded-full mb-2">
                    {t.cases.casesList.saas.category}
                  </span>
                  <h3 className="text-2xl font-bold">{t.cases.casesList.saas.title}</h3>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                  <span className="font-semibold">{t.cases.client}</span>
                  <span>{t.cases.casesList.saas.client}</span>
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed">{t.cases.casesList.saas.description}</p>
                <div>
                  <h4 className="text-lg font-bold mb-3 text-[#0B702A]">{t.cases.results}</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.saas.results[0]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.saas.results[1]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.saas.results[2]}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </article>

            {/* Case 4 */}
            <article className="group bg-[#014421]/30 border border-[#0B702A]/20 rounded-xl overflow-hidden hover:border-[#0B702A]/60 transition-all duration-300 hover:scale-[1.02]">
              <div className="relative h-64 overflow-hidden">
                <img src="https://images.unsplash.com/photo-1619410283995-43d9134e7656?w=600" alt="Case 4" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-3 py-1 bg-[#0B702A] text-white text-xs font-semibold rounded-full mb-2">
                    {t.cases.casesList.corporate.category}
                  </span>
                  <h3 className="text-2xl font-bold">{t.cases.casesList.corporate.title}</h3>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                  <span className="font-semibold">{t.cases.client}</span>
                  <span>{t.cases.casesList.corporate.client}</span>
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed">{t.cases.casesList.corporate.description}</p>
                <div>
                  <h4 className="text-lg font-bold mb-3 text-[#0B702A]">{t.cases.results}</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.corporate.results[0]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.corporate.results[1]}</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-400">
                      <span className="text-[#0B702A] mt-1">✓</span>
                      <span>{t.cases.casesList.corporate.results[2]}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cases;
